import {getResource} from "./common"

export type GettingStartedAttributes = {
	setupAuthentication: boolean
	embedTheComponent: boolean
	setupPrefill: boolean
}

export type ManagedSolutionsStatus = {
	type: "readyToLaunchSetupProgress"
	id: string
	attributes?: GettingStartedAttributes
}

export const getManagedSolutionsStatus = async (accessToken: string) =>
	await getResource<ManagedSolutionsStatus>(`white-label/ready-to-launch-status`, accessToken)
